import React from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'giro-react-toolkit/source/Translation';

import "./OnBoardingItem.scss";

/**
   * renders a summary in the onboarding item
   * @param summary - The summary to display
   */
function Summary(props) {
   return (
      <div className={"summary " + props.className}>
         <span className="summary__description">{props.description}</span>
      </div>);
}

/**
 * Component that shows an OnBoardingItem item
 */
function OnBoardingItem (props) {
   if (!(props.firstSummary && props.secondSummary && props.image))
      return (null);

   return (
      <React.Fragment>
         <div className="onboarding-item">
            <div className="onboarding-img">
               <img className="onboarding-item__pane" src={props.image} alt="Image"/>
            </div>
            <div className="onboarding-title">
               <h1>
                  <Translation resourceKey={ 'ReachMapRes.LandingTitleText' } />
               </h1>
            </div>
            <Summary className="summary--first" {...props.firstSummary} />
            <Summary className="summary--second" {...props.secondSummary} />
         </div>
      </React.Fragment>
   );
}

OnBoardingItem.propTypes = {
   /**
    * defines the image to display in the onboarding item.
    */
   image: PropTypes.string,
   /**
    * defines the first summary to display in the onboarding item.
    */
   firstSummary: PropTypes.object,
   /**
    * defines the second summary to display in the onboarding item.
    */
   secondSummary: PropTypes.object
};

export default OnBoardingItem;
